<template>
  <main id="content">
    <section class="pt-4 pb-4">
      <b-container style="max-width: 900px">
        <b-row>
          <b-col md="4">
            <SettingsNav />
          </b-col>
          <b-col md="8">
            <div class="card card-body">
              <p class="text-danger" v-if="payment_staus">
                Create a subscription, please add credit card details
                <router-link to="/settings/payment">Click Here</router-link>
              </p>
              <p>
                For free subscription please select Free Plan Subscription
              </p>
            </div>
            <div class="card card-body">
              <h2 class="h4 mb-3">My Subscriptions</h2>
              <div
                v-if="loading1"
                class="d-flex justify-content-center pt-5 pb-5 text-muted"
              >
                <font-awesome-icon icon="sync" size="2x" spin />
              </div>
              <div v-else-if="subscriptions.length > 0">
                <div
                  class="card card-body"
                  v-for="subscription in subscriptions"
                  :key="subscription.id"
                >
                  <div>
                    <h5 style="text-transform: capitalize">
                      <span
                        style="text-transform: none"
                        v-if="subscription.metadata.friendly_name"
                        >{{ subscription.metadata.friendly_name + " - " }}</span
                      >
                      {{ subscription.plan.nickname }}
                      <b-badge :class="'badge ' + subscription.status">
                        {{ subscription.status }}
                      </b-badge>
                      <b-badge
                        v-if="subscription.cancel_at_period_end"
                        :class="'badge non_renewing'"
                        >Non Renewing</b-badge
                      >
                      <b-badge
                        v-if="subscription.plan.amount === 0"
                        :class="'badge future'"
                        >Free</b-badge
                      >
                    </h5>
                    <!-- <div>
                      <strong>Subscription ID:</strong>
                      {{ subscription.id }}
                    </div> -->
                    <div v-if="subscription.metadata.company_name">
                      <strong>Company Name:</strong>
                      {{ subscription.metadata.company_name.toUpperCase() }}
                    </div>
                    <div v-if="subscription.metadata.billing_address">
                      <strong>Billing Address:</strong>
                      {{ subscription.metadata.billing_address.toUpperCase() }}
                    </div>
                    <div>
                      <strong>Price:</strong>
                      {{ subscription.plan.currency.toUpperCase() }}
                      {{ subscription.plan.amount / 100 }} / user /
                      {{ subscription.plan.interval }}
                    </div>
                    <div>
                      <strong>Number of users:</strong>
                      {{ subscription.quantity }}
                    </div>
                    <div>
                      <strong>Created on:</strong>
                      {{
                        new Date(
                          subscription.created * 1000
                        ).toLocaleDateString("en-us", {
                          month: "short",
                          day: "numeric",
                          year: "numeric"
                        })
                      }}
                    </div>
                    <div v-if="subscription.cancel_at_period_end">
                      <strong>Ending on:</strong>
                      {{
                        new Date(
                          subscription.current_period_end * 1000
                        ).toLocaleDateString("en-us", {
                          month: "short",
                          day: "numeric",
                          year: "numeric"
                        })
                      }}
                    </div>
                    <div
                      v-if="
                        !subscription.cancel_at_period_end &&
                          subscription.status !== 'canceled'
                      "
                    >
                      <strong>Next billing on:</strong>
                      {{
                        new Date(
                          subscription.current_period_end * 1000
                        ).toLocaleDateString("en-us", {
                          month: "short",
                          day: "numeric",
                          year: "numeric"
                        })
                      }}
                    </div>
                    <div
                      v-if="
                        subscription.cancel_at_period_end ||
                          subscription.status === 'canceled'
                      "
                      class="text-danger"
                    >
                      <div>
                        <strong>Cancelled on:</strong>
                        {{
                          new Date(
                            subscription.canceled_at * 1000
                          ).toLocaleDateString("en-us", {
                            month: "short",
                            day: "numeric",
                            year: "numeric"
                          })
                        }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="mt-3"
                    v-if="
                      !subscription.cancel_at_period_end &&
                        subscription.status !== 'canceled'
                    "
                  >
                    <b-button
                      id="btnSubscriptionsDetailsButton"
                      :to="'/settings/subscription/' + subscription.id"
                      variant="primary"
                      class="icon-left m-1"
                    >
                      <font-awesome-icon icon="info-circle" />Details
                    </b-button>
                    <template v-if="user.stripeId == subscription.customer">
                      <b-button
                        v-if="subscription.plan.amount !== 0"
                        id="btnSubscriptionsAssignButton"
                        :to="'/settings/subscription/' + subscription.id"
                        variant="primary"
                        class="icon-left m-1"
                      >
                        <font-awesome-icon icon="user" />Assign
                      </b-button>
                      <b-button
                        id="btnSubscriptionsCancelButton"
                        v-b-modal="'deleteModal' + '-' + subscription.id"
                        variant="danger"
                        class="icon-left m-1"
                      >
                        <font-awesome-icon icon="trash" />Cancel
                      </b-button>
                      <b-modal
                        :id="'deleteModal' + '-' + subscription.id"
                        title="Cancel subscription"
                        @ok="deleteSubscription(subscription.id)"
                        ok-variant="danger"
                        ok-title="Yes, cancel my subscription"
                        cancel-title="No, don't cancel"
                      >
                        <p>
                          Are you sure you want to cancel your subscription? You
                          or your assignees will not be able to read or write
                          any data after cancellation.
                        </p>
                        <p>
                          <b>
                            Your subscription will be cancelled at the end of
                            the current billing cycle:
                            {{
                              new Date(
                                subscription.current_period_end * 1000
                              ).toLocaleDateString("en-us", {
                                month: "short",
                                day: "numeric",
                                year: "numeric"
                              })
                            }}
                          </b>
                        </p>
                        <p>
                          Advance charges, if any, will be refunded as credits.
                        </p>
                      </b-modal>
                    </template>
                  </div>
                  <div class="mt-3" v-else>
                    <b-button
                      id="btnDetailofSubscrptionButton"
                      :to="'/settings/subscription/' + subscription.id"
                      variant="primary"
                      class="icon-left m-1"
                    >
                      <font-awesome-icon icon="info-circle" />Details
                    </b-button>
                    <span v-if="user.stripeId == subscription.customer">
                      <b-button
                        id="btnReactivateSubscrptionButton"
                        @click="reactivateSubscription(subscription.id)"
                        variant="primary m-1"
                      >
                        Reactivate
                        <font-awesome-icon icon="arrow-Right" />
                      </b-button>
                    </span>
                  </div>
                </div>
              </div>
              <div v-else class="text-center pt-4 pb-3 text-muted">
                <div class="d-flex justify-content-center mb-3">
                  <font-awesome-icon icon="exclamation-triangle" size="3x" />
                </div>
                <div class="h5">You have no subscriptions</div>
                <p style="text-align:center;opacity:0.5;">
                  Please ensure that you have a valid payment method active.
                </p>
              </div>
            </div>
            <div>
              <div class="card card-body mt-4">
                <h2 class="h4 mb-3">
                  <!--<span v-if="subscriptions.length > 0">Update</span>-->
                  <span>Create New</span> Subscription
                </h2>
                <div
                  v-if="loadingPlanDetails"
                  class="d-flex justify-content-center pt-5 pb-5 text-muted"
                >
                  <font-awesome-icon icon="sync" size="2x" spin />
                </div>

                <b-form v-else @submit.prevent>
                  <div v-if="true">
                    <b-form-group label="Pricing Plan">
                      <b-form-select
                        id="selectSubscriptionsPricingPlanField"
                        :options="subscriptionTypeOptions"
                        v-model="newSubscription.type"
                        :state="
                          $v.newSubscription.type.$dirty
                            ? !$v.newSubscription.type.$error
                            : null
                        "
                        aria-describedby="new-sub-type-input-live-feedback"
                        @blur="$v.newSubscription.type.$touch()"
                      />
                      <b-form-invalid-feedback
                        id="new-sub-type-input-live-feedback"
                      >
                        <p>
                          <span
                            v-if="
                              !$v.newSubscription.name.validSubscriptionType
                            "
                            >Please select a pricing plan <br />
                          </span>
                          <span v-if="!$v.newSubscription.type.required">
                            This is a required field.
                          </span>
                        </p>
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group label="Friendly Name">
                      <b-form-input
                        id="txtSubscriptionsFriendlyNameField"
                        trim
                        v-model="newSubscription.name"
                        :state="
                          $v.newSubscription.name.$dirty
                            ? !$v.newSubscription.name.$error
                            : null
                        "
                        aria-describedby="new-sub-name-input-live-feedback"
                        @blur="$v.newSubscription.name.$touch()"
                        placeholder="Enter a friendly name for subscription"
                        type="text"
                        v-bind:readonly="isReadOnly"
                      />
                      <b-form-invalid-feedback
                        id="new-sub-name-input-live-feedback"
                      >
                        <p>
                          <span v-if="!$v.newSubscription.name.maxLength"
                            >Name can be at most
                            {{ $v.newSubscription.name.$params.maxLength.max }}
                            characters. <br />
                          </span>
                          <span v-if="!$v.newSubscription.name.required">
                            This is a required field.
                          </span>
                        </p>
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                      label="Company Name"
                      v-if="
                        newSubscription.type ===
                          dataNames.subscriptions.type.paid
                      "
                    >
                      <b-form-input
                        id="txtSubscriptionsCompanyNameField"
                        trim
                        v-model="newSubscription.CompanyName"
                        :state="
                          $v.newSubscription.CompanyName.$dirty
                            ? !$v.newSubscription.CompanyName.$error
                            : null
                        "
                        aria-describedby="new-company-name-input-live-feedback"
                        @blur="$v.newSubscription.CompanyName.$touch()"
                        placeholder="Enter a Company Name"
                        type="text"
                      />
                      <b-form-invalid-feedback
                        id="new-company-name-input-live-feedback"
                      >
                        <p>
                          <span v-if="!$v.newSubscription.CompanyName.maxLength"
                            >Name can be at most
                            {{
                              $v.newSubscription.CompanyName.$params.maxLength
                                .max
                            }}
                            characters. <br />
                          </span>
                        </p>
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                      label="Billing Address"
                      v-if="
                        newSubscription.type ===
                          dataNames.subscriptions.type.paid
                      "
                    >
                      <b-form-textarea
                        id="txtSubscriptionsBillingAddressField"
                        trim
                        v-model="newSubscription.BillingAddress"
                        :state="
                          $v.newSubscription.BillingAddress.$dirty
                            ? !$v.newSubscription.BillingAddress.$error
                            : null
                        "
                        aria-describedby="new-billing-address-input-live-feedback"
                        @blur="$v.newSubscription.BillingAddress.$touch()"
                        placeholder="Enter a billing address"
                        rows="3"
                        max-rows="6"
                      ></b-form-textarea>
                      <b-form-invalid-feedback
                        id="new-billing-address-input-live-feedback"
                      >
                        <p>
                          <span
                            v-if="!$v.newSubscription.BillingAddress.maxLength"
                            >Name can be at most
                            {{
                              $v.newSubscription.BillingAddress.$params
                                .maxLength.max
                            }}
                            characters. <br />
                          </span>
                        </p>
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                      v-if="
                        newSubscription.type ===
                          dataNames.subscriptions.type.paid
                      "
                      label="Number of users"
                    >
                      <b-form-input
                        id="txtSubscriptionsNumberOfuserField"
                        type="number"
                        number
                        min="1"
                        v-model="newSubscription.seats"
                        :state="
                          $v.newSubscription.seats.$dirty
                            ? !$v.newSubscription.seats.$error
                            : null
                        "
                        @blur="$v.newSubscription.seats.$touch()"
                        aria-describedby="new-sub-seats-input-live-feedback"
                      />
                      <b-form-invalid-feedback
                        id="new-sub-seats-input-live-feedback"
                      >
                        Please enter a number greater than 0.
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <transition name="fade">
                      <b-alert v-model="showPriceDetails" variant="info">
                        <p
                          v-if="
                            !(this.planDetails === null) &&
                              newSubscription.type ===
                                dataNames.subscriptions.type.paid
                          "
                        >
                          Your card will be charged
                          <strong>
                            {{ planDetails.currency.toUpperCase() }}
                            {{
                              (planDetails.amount / 100) * newSubscription.seats
                            }}
                            for
                            {{ newSubscription.seats }}
                            users
                          </strong>
                          today.
                        </p>
                      </b-alert>
                    </transition>
                  </div>
                  <div v-else>
                    <!-- <h4 class="h5">Step 1: Select a subscription to update</h4> -->
                    <!-- Add a selector for updating -->
                    <!-- <h4 class="h5">Step 2: Enter updated number of users</h4> -->
                    <b-form-group label="Update users">
                      <b-form-input
                        type="number"
                        min="1"
                        v-model="updateSubscription_n"
                      />
                    </b-form-group>
                    <!-- Modify deets based on stuff  -->
                    <div>
                      <strong>Current users:</strong>
                      {{ subscriptions[0].quantity }}
                    </div>
                    <div>
                      <strong>Changed users:</strong>
                      {{
                        subtractNumbers(
                          updateSubscription_n,
                          subscriptions[0].quantity
                        )
                      }}
                    </div>
                    <div v-if="subscriptions.length > 0">
                      <strong>Updated number of users:</strong>
                      {{ updateSubscription_n }}
                    </div>
                    <p></p>
                    <p>
                      Your card will be charged
                      <strong>
                        USD
                        <span
                          v-if="
                            updateSubscription_n > subscriptions[0].quantity
                          "
                        >
                          {{
                            subtractNumbers(
                              updateSubscription_n,
                              subscriptions[0].quantity
                            ) * this.subscriptionPrice
                          }}
                          for
                          {{ updateSubscription_n - subscriptions[0].quantity }}
                          new users
                        </span>
                        <span v-else>0</span>
                      </strong>
                      today.
                    </p>
                    <p></p>
                  </div>
                  <transition name="fade">
                    <div v-if="payment_staus && newSubscription.type == 'paid'">
                      <b-button v-b-modal.modal-1 variant="primary">
                        Create new subscription
                        <font-awesome-icon icon="arrow-right" />
                      </b-button>
                      <b-modal
                        id="modal-1"
                        title="Card Details Not Found"
                        hide-footer
                      >
                        <p class="my-2">Please add card details</p>
                        <b-button
                          variant="primary"
                          to="/settings/payment"
                          class="my-2"
                        >
                          Add Card
                        </b-button>
                      </b-modal>
                    </div>
                    <div v-else>
                      <b-button
                        v-if="false"
                        type="submit"
                        variant="primary"
                        @click="
                          updationAction(
                            subscriptions[0].id,
                            updateSubscription_n
                          )
                        "
                      >
                        <span v-if="!isSendingForm">
                          Update subscription
                          <font-awesome-icon icon="arrow-right" />
                        </span>
                        <span v-else>
                          Updating subscription &nbsp;
                          <font-awesome-icon icon="sync" spin />
                        </span>
                      </b-button>
                      <b-button
                        id="btnSubscriptionsCreateNewButton"
                        v-else
                        type="submit"
                        variant="primary"
                        @click="subscriptionAction()"
                        :disabled="
                          $v.newSubscription.$invalid ||
                            isSendingForm ||
                            free_subscription
                        "
                      >
                        <span v-if="!isSendingForm">
                          Create new subscription
                          <font-awesome-icon icon="arrow-right" />
                        </span>
                        <span v-else>
                          Creating subscription &nbsp;
                          <font-awesome-icon icon="sync" spin />
                        </span>
                      </b-button>
                    </div>
                  </transition>
                  <br />
                  <span
                    v-if="free_subscription && newSubscription.type == 'free'"
                    class="text-danger"
                    style="font-size:12px;"
                    >Only One Free Subscription Allow</span
                  >
                </b-form>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import {
  createNewSubscription,
  cancelSubscription,
  reactivateSubscription,
  updateSubscription,
  getStripeCustomerId,
  getPlanDetails,
  getCreditCardDetails
} from "../modules/database";
import constants from "../modules/constants";
const dataNames = constants.dataNames;

import SettingsNav from "../components/SettingsNav.vue";

import { validationMixin } from "vuelidate";
import {
  required,
  integer,
  minValue,
  maxLength,
  helpers
} from "vuelidate/lib/validators";

const validPlanTypes = [
  dataNames.subscriptions.type.free,
  dataNames.subscriptions.type.paid
];

const isSubscriptionTypeValid = () => value => {
  let isTypeValid = validPlanTypes.includes(value);
  return !helpers.req(value) || isTypeValid;
};

export default {
  data() {
    return {
      updateSubscription_n: 0,
      plans: [],
      subscriptionPrice: 0,
      isSendingForm: false,
      loading1: false,
      loading2: false,
      newSubscription: this.freshNewSubscription(),
      loadingPlanDetails: false,
      planDetails: null,
      dataNames: dataNames,
      free_subscription: false,
      payment_staus: true,
      isReadOnly: false,
      subscriptionTypeOptions: [
        { value: dataNames.subscriptions.type.free, text: "Free" },
        { value: dataNames.subscriptions.type.paid, text: "Premium" }
      ]
    };
  },
  mixins: [validationMixin],
  validations: {
    newSubscription: {
      seats: {
        required: required,
        integer: integer,
        minValue: minValue(1)
      },
      name: {
        required: required,
        maxLength: maxLength(30)
      },
      type: {
        required: required,
        validSubscriptionType: isSubscriptionTypeValid()
      },
      CompanyName: {
        required: required,
        maxLength: maxLength(30)
      },
      BillingAddress: {
        maxLength: maxLength(100)
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      customer: "getCustomer",
      subscriptions: "getSubscriptions"
    }),
    showPriceDetails() {
      return (
        !(this.planDetails === null) &&
        this.$v.newSubscription.$anyDirty &&
        !this.$v.newSubscription.seats.$invalid &&
        this.newSubscription.type === dataNames.subscriptions.type.paid
      );
    },
    newSubscriptionType() {
      return this.newSubscription.type;
    }
  },
  mounted() {
    this.loading2 = false;
    this.listSubscriptions();
    this.getStripeCustomerId();
    // fetch plan price
    this.loadPlanDetails();
    getCreditCardDetails()
      .then(card => {
        if (card) this.payment_staus = false;
      })
      .catch(error => {
        console.log("error", error);
        this.payment_staus = true;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  watch: {
    newSubscriptionType(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue === dataNames.subscriptions.type.free) {
          this.newSubscription.seats = 1;
          this.newSubscription.name = "Free Plan";
          this.isReadOnly = true;
          this.checkfreesubscription();
        } else {
          this.isReadOnly = false;
          this.newSubscription.name = "";
          this.free_subscription = false;
        }
      }
    }
  },
  methods: {
    async loadPlanDetails() {
      this.loadingPlanDetails = true;
      try {
        this.planDetails = await getPlanDetails(
          dataNames.subscriptions.type.paid
        );
      } finally {
        this.loadingPlanDetails = false;
      }
    },
    checkfreesubscription() {
      if (this.newSubscription.type == "free") {
        for (let single_sub of this.subscriptions) {
          if (single_sub.plan.amount == 0) {
            this.free_subscription = true;
          }
        }
      } else {
        // this.isReadOnly = false;
        this.free_subscription = true;
      }
    },
    freshNewSubscription() {
      return {
        seats: 1,
        name: "",
        type: dataNames.subscriptions.type.paid,
        CompanyName: "",
        BillingAddress: ""
      };
    },
    getStripeCustomerId() {
      getStripeCustomerId()
        .then(returned => {
          // this.user.stripeId = returned.stripeId;
          this.$store.dispatch("updateUserStripeId", returned.stripeId);
          this.$forceUpdate();
        })
        .catch(() => {
          this.$root.toast(constants.errors.fetch_by_email_error);
        });
    },
    addNumbers(one, two) {
      if (isNaN(parseInt(one) + parseInt(two))) {
        return 0;
      } else {
        return parseInt(one) + parseInt(two);
      }
    },
    subtractNumbers(one, two) {
      if (isNaN(parseInt(one) - parseInt(two))) {
        return 0;
      } else {
        return parseInt(one) - parseInt(two);
      }
    },
    deleteSubscription(id) {
      this.loading1 = true;
      cancelSubscription(id)
        .then(() => {
          this.$root.toast(constants.info.subscription_deleted);
          this.listSubscriptions();
        })
        .catch(() => {
          this.$root.toast(constants.errors.subscription_cancel_error);
        })
        .finally(() => {
          this.loading1 = false;
        });
    },
    reactivateSubscription(id) {
      this.loading1 = true;
      reactivateSubscription(id)
        .then(() => {
          this.listSubscriptions();
          this.loading1 = false;
        })
        .catch(() => {
          this.$root.toast(constants.errors.subscription_reactivation_error);
        })
        .finally(() => {
          this.loading1 = false;
        });
    },
    listSubscriptions() {
      this.loading1 = true;
      this.subscriptionPrice = 0;
      this.$store.dispatch("fetchUserSubscriptions").finally(() => {
        this.loading1 = false;
      });
    },
    subscriptionAction() {
      this.$v.newSubscription.$touch();
      if (this.$v.newSubscription.$pending || this.$v.newSubscription.$error)
        return;
      this.isSendingForm = true;
      createNewSubscription(
        this.newSubscription.seats,
        this.newSubscription.name,
        this.newSubscription.type,
        this.newSubscription.CompanyName,
        this.newSubscription.BillingAddress
      )
        .then(() => {
          this.newSubscription = this.freshNewSubscription();
          this.$root.toast(constants.info.subscription_created);
          this.$v.newSubscription.$reset();
          this.isSendingForm = false;
          this.listSubscriptions();
        })
        .catch(error => {
          // this.show = false;
          this.$root.toast(error);
        })
        .finally(() => {
          this.isSendingForm = false;
        });
    },
    updationAction(id, quantity) {
      if (quantity < 1) {
        return;
      }
      if (quantity == this.subscriptions[0].quantity) {
        return;
      }
      this.loading1 = true;
      updateSubscription(id, quantity)
        .then(() => {
          this.$root.toast(constants.info.subscription_updated);
          this.isSendingForm = false;
          this.listSubscriptions();
        })
        .catch(error => {
          this.$root.toast(error);
        })
        .finally(() => {
          this.loading1 = false;
        });
    }
  },
  components: {
    SettingsNav
  }
};
</script>
<style>
body {
  background-color: #fff;
}
</style>
